<script>
import { version } from "../package.json"
import { mapState } from 'vuex'
import { isMobile } from 'mobile-device-detect'

export default {
  components: {
	},
  data () {
    return {
      isMobile: isMobile,
      appVersion: version,
    }
  },
  computed: {
    ...mapState({
      usuario: state => state.moduleLogin.usuario,
      user: state => state.moduleLogin.user
    }),
    isIdle() {
      return this.$store.state.modulePrincipal.idleVue.isIdle
    }
  },
  onIdle() {
    this.$store.state.modulePrincipal.idleVue.isIdle = true
    var e = this;
    if (this.usuario.codUsuario > 0){
      this.time = this.usuario.tmpOcioso * 60;
      var t = setInterval((function() {
          e.time -= 1, e.$store.state.modulePrincipal.idleVue.isIdle || clearInterval(t), e.time < 1 && (clearInterval(t), alert("Tempo Limite de " + e.usuario.tmpOcioso + " minutos inatividade...."), location.reload())
      }), 1e3)
    }
  },
  onActive() {
    this.$store.state.modulePrincipal.idleVue.isIdle = false
  },
  methods:{
    logoff() {
      location.reload()
    },
    nomeAbrev(palavra){
      try {
        return palavra.charAt(0).toUpperCase()
      } catch {
        return ''
      }
    }
  }
}
</script>

<template>
  <div id="app">
    <b-nav pills id="nav" v-show="usuario && usuario.codUsuario > 0"> 
      
      <b-sidebar id="sidebar-left" title="Pesquisa Web" backdrop-variant="dark" backdrop shadow left>
        <hr>
        <h6 class="menu_principal">---------------- Inicio ----------------</h6>
        <b-dropdown-item v-if="usuario.codUsuario > 0" to="/Home">
          <font-awesome-icon :icon="['fas', 'home']" />
          <span class="menu_pesquisa"> Inicio </span>
        </b-dropdown-item>
        <hr>
        <h6 class="menu_principal">---------------- Pesquisa ----------------</h6>
        <b-dropdown-item v-if="usuario.codUsuario > 0" to="/PesquisaPlacas">
          <font-awesome-icon :icon="['fas', 'photo-video']" />
          <span class="menu_pesquisa"> Pesquisa Placas </span>
        </b-dropdown-item>
        <hr>
        <h6 class="menu_principal">---------------- Telegram ----------------</h6>
        <b-dropdown-item v-if="usuario.codUsuario > 0" to="/CadastroTelegram">
          <font-awesome-icon :icon="['fab', 'telegram-plane']" />
          <span class="menu_pesquisa"> Cadastro Telegram </span>
        </b-dropdown-item>
        <hr>
        <h6 class="menu_principal">---------------- Alerta ----------------</h6>
        <b-dropdown-item v-if="usuario.codUsuario > 0" to="/CadastroAlerta">
          <font-awesome-icon :icon="['fas', 'book']" />
          <span class="menu_pesquisa"> Cadastro Alerta </span>
        </b-dropdown-item>
        <hr>
        <h6 class="menu_principal" v-if="user.cidade == 'Itaipu'">---------------- Email ----------------</h6>
        <b-dropdown-item v-if="usuario.codUsuario > 0 && user.cidade == 'Itaipu'" to="/CadastroEmail">
          <font-awesome-icon :icon="['fas', 'envelope']" />
          <span class="menu_pesquisa"> Cadastro Email </span>
        </b-dropdown-item>
        <hr>
        <template #footer="{ hide }">
          <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
            <strong class="mr-auto">Versao: {{appVersion}}</strong>
            <b-button size="sm" @click="hide"><b-icon icon="x" aria-hidden="true" animation="fade"></b-icon> Fechar</b-button>
          </div>
        </template>
      </b-sidebar>

      <b-button class="btn-margem" v-b-toggle.sidebar-left title="Menu">
        <b-icon icon="list" font-scale="1" color="white" animation="cylon"></b-icon>
      </b-button>

      <b-nav-item class="ml-auto" >
        <h6>
          <b-avatar variant="dark" icon="person-badge" :badge="nomeAbrev(usuario.nomUsuario)"></b-avatar>
          <strong v-show="!isMobile">
            {{ usuario.nomUsuario }}
          </strong>
          <b-avatar variant="dark" icon="map" :badge="nomeAbrev(user.cidade)"></b-avatar>
          <strong v-show="!isMobile">
            {{ user.cidade }}
          </strong>
        </h6>
      </b-nav-item>

      <b-nav-item v-show="usuario.nomUsuario != ''" class="ml-auto">
        <button type="button" class="btn btn_sair btn-outline-danger" @click="logoff" >
          <b-icon icon="door-open"></b-icon> 
          Sair 
        </button>
      </b-nav-item>
    </b-nav>
    <router-view/>
  </div>
</template>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100vh;
  color: #2c3e50;
  background-color: #6c7a89;
}

#nav {
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.175);
}

#nav a {
  font-weight: bold;
  color: #f8f8ff;
}

#nav a.router-link-exact-active {
  color: #242d36;

}

html, body {
  height: 100vh;
}

.btn-margem{
  margin: 2px
}

.menu_principal{
  color: whitesmoke !important;
  font-weight: bold;
}

#sidebar-left___title__{
  color: whitesmoke !important;
}

.close{
  color: whitesmoke !important;
}

.btn_pesquisa, .btn_sair {
  background-color: #f8f8ff!important;
}

.dropdown-menu{
  background-color: #2c3e50 !important;
}

.b-sidebar-body{
  background-color: #505668;
}

.b-sidebar-header{
  background-color: #505668;
}
</style>
